// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BzBXbo {
  width: 100%;
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.tJB7Hq {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-3);
  margin-top: var(--spacing-3);
}

.LwHEze {
  margin: 0;
  text-align: left;
  font-family: var(--font-family-base);
  font-size: var(--type-paragraph-md-font-size);
  font-weight: var(--type-paragraph-md-regular-font-weight);
  line-height: var(--type-paragraph-md-regular-line-height);
  color: var(--text-neutral-dark);
}

.HS4Y1Z {
  margin: 0;
}

.BM5Bgf {
  font-weight: var(--font-weight-semibold);
}
`, "",{"version":3,"sources":["webpack://./../../packages/beneficios/src/pages/NewRechargePage/components/EmissorDeliveryAddress/EmissorDeliveryAddress.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,OAAO;EACP,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,oCAAoC;EACpC,6CAA6C;EAC7C,yDAAyD;EACzD,yDAAyD;EACzD,+BAA+B;AACjC;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,wCAAwC;AAC1C","sourcesContent":[".wizardCardShell {\n  width: 100%;\n  flex: 1;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n}\n\n.stepContent {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-3);\n  margin-top: var(--spacing-3);\n}\n\n.description {\n  margin: 0;\n  text-align: left;\n  font-family: var(--font-family-base);\n  font-size: var(--type-paragraph-md-font-size);\n  font-weight: var(--type-paragraph-md-regular-font-weight);\n  line-height: var(--type-paragraph-md-regular-line-height);\n  color: var(--text-neutral-dark);\n}\n\n.shippingInfo {\n  margin: 0;\n}\n\n.shippingInfoLabel {\n  font-weight: var(--font-weight-semibold);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wizardCardShell": `BzBXbo`,
	"stepContent": `tJB7Hq`,
	"description": `LwHEze`,
	"shippingInfo": `HS4Y1Z`,
	"shippingInfoLabel": `BM5Bgf`
};
module.exports = ___CSS_LOADER_EXPORT___;
